module.exports = __webpack_public_path__ + "img/nitrox_tokencreate.55b83c7.png";